exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-header[data-v-0734163b]{background-color:#fef7ea}.modal-body[data-v-0734163b]{font-size:.8rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0734163b&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal/CanNotOperateWithinDemoAlert.vue
// module id = 478
// module chunks = 0